import React from 'react';
import { useEstructura } from '../context/EstructuraContext';
import Equipos      from './components/Equipos';
import InformeModal from './components/InformeModal';

export default function Home() {
  const {
    equipos,
    mensaje,
    modalEquipoSeleccionado,
    setModalEquipoSeleccionado
  } = useEstructura();

  return (
    <div className="flex flex-col min-h-screen">
      <main className="flex-1 p-6">
        <Equipos
          equipos={equipos}
          mensaje={mensaje}
          onInforme={setModalEquipoSeleccionado}
        />
      </main>

      {modalEquipoSeleccionado && (
        <InformeModal
          equipo={modalEquipoSeleccionado}
          onClose={() => setModalEquipoSeleccionado(null)}
        />
      )}
    </div>
  );
}
